<div class="error-container">
  <h1>{{ 'error.page.' + errorCode + '.title' | translate }}</h1>
  <h3>Error code: {{ errorCode }}</h3>
  <p>{{ 'error.page.' + errorCode + '.description' | translate }}</p>
  <button mat-raised-button color="primary" routerLink="/">
    {{ 'error.page.' + errorCode + '.button' | translate }}
  </button>
  <img [src]="'../assets/img/' + errorCode + '.svg'" />
</div>
